"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalAppSwitcher_enum_exports = {};
__export(GlobalAppSwitcher_enum_exports, {
  AppsList: () => AppsList,
  analyticsIdGenerator: () => analyticsIdGenerator,
  getAppFrom: () => getAppFrom,
  getApps: () => getApps,
  getAppsKey: () => getAppsKey
});
module.exports = __toCommonJS(GlobalAppSwitcher_enum_exports);
var import_assets = require("./assets");
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var AppsList = {
  insync: {
    key: "in-sync",
    label: "Great Minds in Sync",
    ariaLabelItem: "Switch to Great Minds in Sync",
    urlIcon: import_assets.insyncLogo,
    url: "/auth/launch/in-sync"
  },
  affirm: {
    key: "affirm",
    label: "Affirm",
    ariaLabelItem: "Switch to Affirm",
    urlIcon: import_assets.affirmLogo,
    url: "/auth/launch/affirm"
  },
  em: {
    key: "em-nav",
    label: "Eureka Math Navigator",
    ariaLabelItem: "Switch to Eureka Math Navigator",
    urlIcon: import_assets.emnavLogo,
    url: "/auth/launch/eureka-math-navigator"
  },
  digital: {
    key: "digital",
    label: "Eureka Math\xB2",
    ariaLabelItem: "Switch to Eureka Math Squared",
    urlIcon: import_assets.digitalLogo,
    url: "/auth/launch/explore"
  },
  dte: {
    key: "inkling",
    label: "Digital Teacher Edition",
    ariaLabelItem: "Switch to Digital Teacher Edition",
    urlIcon: import_assets.inklingLogo,
    url: "/auth/launch/inkling"
  },
  gm: {
    key: "gm",
    label: "GreatMinds.Org Dashboard",
    ariaLabelItem: "Switch to GreatMinds.Org Dashboard",
    urlIcon: import_assets.otherResourcesLogo,
    url: "/auth/launch/other-resources"
  },
  um: {
    key: "um",
    label: "Manage",
    ariaLabelItem: "Switch to Manage",
    urlIcon: import_assets.manageLogo,
    url: "/user-management/school-management"
  },
  geodesdig: {
    key: "geodesdig",
    label: "My Geodes",
    ariaLabelItem: "Switch to My Geodes",
    urlIcon: import_assets.myGeodesLogo,
    url: "/auth/launch/geodes"
  }
};
function getApps() {
  return [AppsList.insync, AppsList.affirm, AppsList.em, AppsList.digital, AppsList.dte, AppsList.um, AppsList.gm, AppsList.geodesdig];
}
function getAppsKey() {
  return [AppsList.insync.key, AppsList.affirm.key, AppsList.em.key, AppsList.digital.key, AppsList.dte.key, AppsList.um.key];
}
function getAppFrom(value) {
  return getApps().find(function(app) {
    return app.key === value;
  });
}
var analyticsIdGenerator = function analyticsIdGenerator2(key) {
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, AppsList.affirm.key, "GlobalElementsGlobalAppSwitcherAffirmButton"), AppsList.insync.key, "GlobalElementsGlobalAppSwitcherInSyncButton"), AppsList.digital.key, "GlobalElementsGlobalAppSwitcherGreatMindsDigital"), AppsList.gm.key, "GlobalElementsGlobalAppSwitcherGreatmindsDashboardButton"), AppsList.em.key, "GlobalElementsGlobalAppSwitcherEurekaMathNavigatorButton"), AppsList.um.key, "GlobalElementsGlobalAppSwitcherManageButton"), AppsList.dte.key, "GlobalElementsGlobalAppSwitcherDigitalTeacherEditionButton"), AppsList.geodesdig.key, "GlobalElementsGlobalAppSwitcherMyGeodesButton")[key];
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AppsList,
  analyticsIdGenerator,
  getAppFrom,
  getApps,
  getAppsKey
});
//# sourceMappingURL=GlobalAppSwitcher.enum.js.map